// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-group .btn[data-v-a0ab6b00] {\n  background-color: #bdbdbd;\n}\n.btn-group .active[data-v-a0ab6b00] {\n  background-color: #24abc9;\n  color: white;\n}\n.form-control-override-readonly[data-v-a0ab6b00] {\n  background-color: #fff !important;\n}\n.vdp-datepicker__clear-button[data-v-a0ab6b00] {\n  position: absolute;\n  top: 7px;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
